var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionIdIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.19241 15.75L4.24816 11.5673H0.317383L0.605833 10.4327H4.52701L5.74816 5.56727H1.31738L1.60583 4.43267H6.02701L7.06738 0.25H8.17698L7.13658 4.43267H11.6424L12.6827 0.25H13.7923L12.752 4.43267H16.6827L16.4039 5.56727H12.4731L11.252 10.4327H15.6827L15.4039 11.5673H10.9731L9.93273 15.75H8.80776L9.86353 11.5673H5.35776L4.31738 15.75H3.19241ZM5.63658 10.4327H10.1424L11.3635 5.56727H6.85776L5.63658 10.4327Z",
    fill: "#617380"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionIdIcon);
export default __webpack_public_path__ + "static/media/transactionIdIcon.786542d1.svg";
export { ForwardRef as ReactComponent };